import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { BreadCrumbSecttion } from './BreadCrumbSecttion';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import InputField from './InputField';
import SelectDropDown from './SelectDropDown';
import PrimaryOutLineButton from './PrimaryOutLineButton';
import PrimaryGradientButton from './PrimaryGradientButton';
import AlertMsg from './AlertMsg';
import RegistrationService from '../services/registration';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import UploadFile from './UploadFile';
import ProfileService from '../services/Profile';
import { validateDoc } from '../constants/commonFunction';

function KycApprovalUpdate() {
    const navigate = useNavigate();
    const { state } = useLocation();
    

    // 'S.No.' : index+1,
    // 'Name' : item.name,
    // 'Mobile No.' : item.number,
    // 'External Id' : item.id_extern01,
    // 'KYC Approval' : item.document_name

    const kycList = [ {
      title: 'Aadhar',
      id: 'aadharcard',
    },
    {
      title: 'Voter ID',
      id: 'voterId',
    },
    {
      title: 'Driving License',
      id: 'driving_license',
    },
    {
      title: 'PAN',
      id: 'pan',
    }]

    

    const [selectedKyc, setSelectedKyc] = useState({id: "", title: ""})
    const [docNumber, setDocNumber] = useState(state.document_no);
    const [isModify, setIsModify] = useState(false)
    const [loading, setLoading] = useState(false);
    const [frontImage, setFrontImage] = useState("")
    const [backImage, setBackImage] = useState("")
    const [panImage, setPanImage] = useState("")

    function initialize(){
        setDocNumber(state["document_no"])
        const doc = kycList.find(item => item.id == state["KYCType"])
        setSelectedKyc(doc)
        setIsModify(false)
    }
    useEffect(() => {
       initialize()
    }, [])

    const docHandler = (e) => {
        setDocNumber(e.target.value)
    }

    function approveHandler(){
        const payload={
          document_name:String(state.document_name),
          document_id:state.document_id
        }
        setLoading(true);

        RegistrationService.approveDocumentTSE(payload)
        .then(res => {
          setLoading(false)
    
          if (res.success == true) {
            toast.success(res.response)
          } else {
            setLoading(false);
            toast.error(res.response.message)
          }
        })
        .catch(err => {
          setLoading(false);
        }).finally(() => {
            setTimeout(() => {
                navigate(-1)
            }, 3000)
        })
    }

    function submitDocumentHandler() {
      
        
        if(!selectedKyc.id) {
          toast.error("Select KYC Type")
          
        }else if(!docNumber) {
          toast.success('Enter documment number');
          
        }else{
          if(!validateDoc(selectedKyc.title, docNumber)) {
            toast.error(`Invalid ${selectedKyc.title} number`)
            return;
          }
    
          setLoading(true);
          
          const formData = new FormData();
        //   if(selectedKyc.id.toUpperCase()=='PAN') {

        //   }
          if (selectedKyc.id == "pan") {
            if(!panImage) {
                formData.append('pan_image_url', state.file_path[0]);
            } else {
              formData.append('pan_image',panImage.file);
            }
        //   }else{
            
          }
    
          if (selectedKyc.id !== "pan") {
            if(!frontImage || !backImage) {
              if((!frontImage && backImage) || (frontImage && !backImage)) {
                toast.error("Kindly select both the document")
                setFrontImage("")
                setBackImage("")
                return;
              }
                if(!frontImage && !backImage){
                  formData.append('front_image_url', state.file_path[0]);
                  formData.append('back_image_url', state.file_path[1]);
                }
            } else {
              formData.append('front_image', frontImage.file);
              formData.append('back_image', backImage.file);
            }     
          }
          
          formData.append('KYCType', selectedKyc.id?selectedKyc.id:state.KYCType);
          formData.append('KYCDetails', docNumber?docNumber:state.document_no);
          formData.append('contact_id', state.contact_id);
          formData.append('document_id', state.document_id);
          formData.append('updatedBy', 'TSE');
          ProfileService.uploadEkycDoc(formData)
            .then(res => {
              setLoading(false)
    
              if (res.success == true) {
                navigate(-1);
                // navigation.navigate('UnapproveDocumentTSE');
                toast.success(res.response.message);
              } else {
                // setLoading(false);
                initialize()
                toast.show(res.response.message);
              }
            })
            .catch(err => {
              setLoading(false);
              toast.error("Something went wrong")
            }).finally(() => {
              setLoading(false)
            });
        }
    
      }

    function cancelHandler() {
        initialize()
    }

  return (
    <>
    <BreadCrumbSecttion pageTitle="KYC Approval Update" currentPageName="KYC Approval Update" />
    <section className='padTop50'>
        <Container>
            <Row className='justify-content-between align-item-center h-100'>
                <Col xs={6} >
                    <div className='userInfoBox'>
                        <div className='dashboard-title'>
                            <h4>Kyc Approval</h4>
                        </div>
                        <div className="dashboard-details purchaseApprovalWrap">
                            <Row>
                                <Col xs={12} lg={6}>
                                <SelectDropDown
                                    requiredStar="*"
                                    labelName="Please select KYC type"
                                    options={kycList}
                                    selectedValue={selectedKyc}
                                    setSelectedValue={setSelectedKyc}
                                    disabled={!isModify}
                                    // onChange={handleReasonChange} 
                                    />
                                </Col>
                                <Col xs={12} lg={6}>
                                    <InputField inputFieldLabel='Document number'
                                        value={docNumber}
                                        onChange={docHandler}
                                        editable={true}
                                        disabled={!isModify}
                                         />
                                </Col> 
                            </Row>
                            {!isModify && <Row className='mt-3'>
                                <Col xs={12} lg={3}>
                                    <Button variant="warning" className="w-100 h-48" onClick={() => setIsModify(p=> !p)}>Modify</Button>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Button disabled={loading} variant="success" className="w-100 h-48" onClick={approveHandler}>Approve</Button>
                                </Col>

                            </Row>}
                            {isModify && <Row className='mt-3'>
                                <Col xs={12} lg={3}>
                                    <Button disabled={loading} variant="success" className="w-100 h-48" onClick={submitDocumentHandler}>Submit</Button>
                                </Col>
                                <Col xs={12} lg={3}>
                                    <Button variant="warning" className="w-100 h-48" onClick={cancelHandler}>Cancel</Button>
                                </Col>

                            </Row>}
     
                        </div>
                    </div>
                </Col>
                <Col xs={6} >
                    <div className='userInfoBox'>
                        <div className='dashboard-title'>
                            <h4>Images</h4>
                        </div>
                        <div className="dashboard-details purchaseApprovalWrap">
                            {!isModify && <Row>
                            {state.file_path.map(item => {
                                return (
                                        <Col xs={6} lg={3}>
                                            <img src={item} alt='image' width="100%" height={"auto"} />
                                        </Col>
                                )
                            })}
                            </Row>}
                            {isModify && (selectedKyc.title != "PAN" ? (<>
                            <Row>
                                <Col xs={6} lg={6}>
                                <UploadFile label="Upload KYC Front Image"
                                                    requiredStar="*"
                                                    accept="image/*"
                                                    value={frontImage}
                                                    setValue={setFrontImage} />
                                </Col>
                                </Row>
                                <Row>
                                <Col xs={6} lg={6}>
                                <UploadFile label="Upload KYC Back Image"
                                                    requiredStar="*"
                                                    accept="image/*"
                                                    value={backImage}
                                                    setValue={setBackImage} />
                                </Col>
                                </Row>
                            </>) : (<Row>
                                <Col xs={6} lg={6}>
                                <UploadFile label="Upload PAN Image"
                                                    requiredStar="*"
                                                    accept="image/*"
                                                    value={panImage}
                                                    setValue={setPanImage} />
                                </Col>
                            </Row>))}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
</>
  )
}

export default KycApprovalUpdate